(() => {
  const desktop = matchMedia('(min-width: 990px)');
  const listSelector = '.njd-filter-values, .njs-options, .njt-wheels__options';
  const pairs = [
    ['.facets-vertical', '#main-collection-filters', '#product-grid'],
    ['.njs-response', '.njs-sidebar', '.njs-grid'],
    ['.njt-wheels', '.njt-wheels__sidebar', '.njt-wheels__grid']
  ];
  const tracked = new Set();
  const measurements = new WeakMap();
  let measureAgain = true;
  let frame;
  let wasDesktop = desktop.matches;
  const schedule = () => {
    if (!desktop.matches && !wasDesktop) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  function set(element, key, value) {
    if (element.style.getPropertyValue(key) !== value) element.style.setProperty(key, value);
  }
  function update() {
    if (!desktop.matches) {
      resize.disconnect(); tracked.clear();
      if (wasDesktop) {
        document.querySelectorAll('#product-grid, .njs-grid, .njt-wheels__grid').forEach(grid => grid.style.removeProperty('--njt-card-height'));
        document.querySelectorAll('#product-grid>li, .njs-grid>li, .njt-wheels__grid>li').forEach(item => item.style.removeProperty('height'));
        document.querySelectorAll('.njs-sidebar, .njt-wheels__sidebar, #main-collection-filters').forEach(side => {
          side.style.removeProperty('max-height'); side.style.removeProperty('overflow-y');
          side.querySelectorAll(listSelector).forEach(list => list.style.removeProperty('max-height'));
        });
      }
      wasDesktop = false;
      measureAgain = true;
      return;
    }
    wasDesktop = true;
    const alive = new Set();
    const brandPage = Boolean(document.querySelector('.njb-heading')); 
    for (const [parentSelector, sideSelector, gridSelector] of pairs) {
      document.querySelectorAll(parentSelector).forEach(parent => {
        const side = parent.querySelector(sideSelector);
        const grid = parent.querySelector(gridSelector);
        if (!side || !grid) return;
        const items = [...grid.children].filter(item => item.matches('li') && item.querySelector('.njs-card'));
        const width = grid.offsetWidth;
        const previous = measurements.get(grid);
        if (items.length && width && (measureAgain || !previous || previous.width !== width ||
            previous.items.length !== items.length || items.some((item, index) => item !== previous.items[index]))) {
          grid.style.removeProperty('--njt-card-height');
          // Keep measurements in CSS pixels; rendered rectangles include the desktop body zoom.
          const height = Math.max(...items.map(item => item.offsetHeight));
          if (height > 0) set(grid, '--njt-card-height', `${height}px`);
          measurements.set(grid, {width, items});
        }
        for (const element of [side, grid]) {
          alive.add(element);
          if (!tracked.has(element)) { tracked.add(element); resize.observe(element); }
        }
        if (brandPage && side.id === 'main-collection-filters') {
          side.style.removeProperty('max-height');
          side.style.removeProperty('overflow-y');
          side.querySelectorAll(listSelector).forEach(list => list.style.removeProperty('max-height'));
          return;
        }
        const cards = [...grid.children].filter(item => item.matches('li') && item.offsetHeight > 0).slice(0, 6);
        const allLists = [...side.querySelectorAll(listSelector)];
        for (const element of [side, grid, ...cards]) {
          alive.add(element);
          if (!tracked.has(element)) { tracked.add(element); resize.observe(element); }
        }
        if (!desktop.matches || !cards.length || !side.offsetHeight) {
          side.style.removeProperty('max-height');
          side.style.removeProperty('overflow-y');
          allLists.forEach(list => list.style.removeProperty('max-height'));
          return;
        }
        const rowHeight = group => Math.max(...group.map(card => card.offsetHeight), 0);
        const budget = Math.floor(rowHeight(cards.slice(0, 3)) + (cards.length > 3 ? rowHeight(cards.slice(3, 6)) + 18 : 0) - 2);
        const lists = allLists.filter(list => list.offsetHeight > 0);
        const used = lists.reduce((sum, list) => sum + list.offsetHeight, 0);
        const fixed = side.scrollHeight - used;
        let remaining = Math.max(0, budget - fixed);
        const heights = new Map();
        let pending = [...lists];
        while (pending.length) {
          const share = remaining / pending.length;
          const short = pending.filter(list => list.scrollHeight <= share);
          if (!short.length) { pending.forEach(list => heights.set(list, Math.max(0, Math.floor(share)))); break; }
          short.forEach(list => { heights.set(list, list.scrollHeight); remaining -= list.scrollHeight; });
          pending = pending.filter(list => !heights.has(list));
        }
        allLists.forEach(list => {
          if (heights.has(list)) set(list, 'max-height', `${heights.get(list)}px`);
          else list.style.removeProperty('max-height');
        });
        set(side, 'max-height', `${Math.max(0, budget)}px`);
        set(side, 'overflow-y', 'auto');
      });
    }
    measureAgain = false;
    for (const element of tracked) if (!alive.has(element)) { resize.unobserve(element); tracked.delete(element); }
  }
  new MutationObserver(records => {
    const relevant = records.some(record => record.target.closest?.('.facets-vertical, .njs-response, .njt-wheels') ||
      [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches('.facets-vertical, .njs-response, .njt-wheels') || node.querySelector('.facets-vertical, .njs-response, .njt-wheels'))));
    if (relevant) { measureAgain = true; schedule(); }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('toggle', schedule, true);
  desktop.addEventListener('change', schedule);
  window.addEventListener('resize', schedule);
  document.fonts?.ready.then(() => { measureAgain = true; schedule(); });
  schedule();
})();
